<template>
    <div>
      <section class="pb-lg-5 pt-lg-5">
        <b-jumbotron bg-variant="white">
          <template v-slot:header>Page not found</template>
          <h4>
            <router-link :to="{name: 'home'}">Home page</router-link>
          </h4>
        </b-jumbotron>
      </section>
    </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue